import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { contractPdfSchema } from './schemas';

export const contractPdfQueryOptions = (isAddendum: boolean) =>
  queryOptions({
    queryKey: isAddendum ? QueryKeys.contract.addendumPdf : QueryKeys.contract.pdf,
    queryFn: async () => {
      const response = await request('/user/contract');

      const { contract } = z.object({ contract: contractPdfSchema }).parse(response);

      return contract;
    },
    staleTime: Infinity,
  });

/**
 * `/user/contract` only ever returns the document still pending signature, so `enabled` must be
 * set to `false` once the user has already signed everything — there is nothing left to fetch.
 */
export const useContractPdf = (isAddendum: boolean, enabled = true) => {
  return useQuery({ ...contractPdfQueryOptions(isAddendum), enabled });
};
